import * as variables from './variables.js';
import * as $ from 'jquery';

import 'window.requestanimationframe';
import 'es6-promise/auto';
import 'whatwg-fetch';

(window as any).jQuery = $;
import JSFAjaxJQueryAdapter from '@plaudit/jsf-ajax-adapters/dist/jQuery';
JSFAjaxJQueryAdapter.init();

import "./Analytics";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import Forms from './component/Forms';
Forms.init();

import MainMenu from './component/MainMenu';
new MainMenu({
	menu 			: '#menu',
	menuTarget 		: '.menu__inner',
	nodeTarget_slidable : '.childWrap--L2',
	nodeTrigger 	: '.node--hasChild > a, .backToSeeAllConferences > a',
	headTarget 		: '.childWrap__heading',
	triggers 		: '#menuTrigger--open, #menuTrigger--close, #menuOverlay',
	triggerEvent 	: 'click',
	//hideSiblingMenuItems: selectorMatchesConferenceNodes,
	collapsable: {
		duration: 400
	},
	styleClass: {
		setup 			: 'hasMenuSetup',
		menuOpen 		: 'hasMenuOpen',
		nodeOpen 		: 'isOpen',
		backWrap 		: 'childWrap__back'
	}
});

import Masthead from './component/Masthead';
new Masthead('mastheadVideo');

import Gallery from './component/Gallery';
new Gallery();

import ProductsLanding from './component/ProductsLanding';
new ProductsLanding();

import ProductSearch from './component/ProductSearch';
new ProductSearch();

import Product from './component/Product';
new Product();
